import { Component } from '@angular/core';

// AngularFire
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { IMenu } from '@noovle/ui-nav-bar';
import { SpinnerService } from './services/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  menu:IMenu = [
    {
      label:"Page Builder",
      url:"/pages",
    },
    {
      label:"Utenze",
      url:"/users",
      allowedRoles: ['ADMIN', 'ADMIN_VIEWER']
    },
    {
      label:"Dashboards",
      url:"/dashboards",
      allowedRoles: ['ADMIN', 'ADMIN_VIEWER', 'EDITOR']
    },
    {
      label:"Auditing",
      url:"/auditing",
      allowedRoles: ['ADMIN', 'ADMIN_VIEWER']
    },
    {
      label:"Metriche",
      url:"/custom-metrics",
      allowedRoles: ['ADMIN', 'ADMIN_VIEWER', 'EDITOR']
    },
  ] 
  constructor(public fireAuth: AngularFireAuth, public spinner: SpinnerService) {}
}
